import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const SegmentedControlRadioGroupItem = styled(RadixRadioGroup.Item)`
    font-weight: ${theme.fontWeights[500]};
    font-size: ${theme.fontSizes[12]};
    line-height: 16px;
    border-radius: ${theme.radii[4]};
    border: none;
    padding: ${theme.space[4]} 12px;

    transition:
        background-color 150ms ease-in-out,
        box-shadow 150ms ease-in-out;

    &[data-state='checked'] {
        color: ${theme.colors.accent.foreground};
        box-shadow: ${theme.shadows.small};
        background: linear-gradient(
            0deg,
            ${theme.colors.background.subtle} 0%,
            ${theme.colors.background.default} 100%
        );
    }
`;
